module.exports = __webpack_public_path__ + "static/wholesale-product-categories-c93222b9c810b4da9c63e15318cceea1.png";